// ─────────────────────────────────────────────
//  Settings — toggle product features on/off
//  TODO: persist these to Supabase per merchant
// ─────────────────────────────────────────────
import { useState } from "react";

const DEFAULT_SETTINGS = [
  { id: "gating",       label: "Review Gating",          desc: "Privately capture 1–3 star reviews before they go public",      on: true  },
  { id: "alerts",       label: "Instant Alerts",          desc: "SMS + email when a review under 3 stars comes in",              on: true  },
  { id: "incentive",    label: "Thank You Incentive",     desc: "Send a 10% discount code after every review submission",        on: true  },
  { id: "autopublish",  label: "Auto-publish to Google",  desc: "Automatically push approved reviews to Google",                 on: false },
  { id: "digest",       label: "Weekly Digest Email",     desc: "Summary of reviews and rating changes every Monday",            on: true  },
];

export default function Settings() {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);

  const toggle = (id) =>
    setSettings((prev) =>
      prev.map((s) => (s.id === id ? { ...s, on: !s.on } : s))
    );

  return (
    <div style={{ maxWidth: 560 }}>
      <h1 style={{ margin: "0 0 24px", fontSize: 26, fontWeight: 900, letterSpacing: "-0.03em" }}>
        Settings
      </h1>

      {settings.map((s) => (
        <div
          key={s.id}
          style={{
            background: "rgba(255,255,255,0.04)",
            border: "1px solid rgba(255,255,255,0.07)",
            borderRadius: 12, padding: "16px 18px", marginBottom: 10,
            display: "flex", justifyContent: "space-between", alignItems: "center",
          }}
        >
          <div>
            <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 3 }}>{s.label}</div>
            <div style={{ fontSize: 12, color: "rgba(255,255,255,0.35)" }}>{s.desc}</div>
          </div>

          {/* Toggle switch */}
          <div
            onClick={() => toggle(s.id)}
            style={{
              width: 44, height: 24, borderRadius: 12,
              background: s.on ? "#FF6B35" : "rgba(255,255,255,0.1)",
              position: "relative", cursor: "pointer",
              flexShrink: 0, transition: "background 0.2s",
            }}
          >
            <div
              style={{
                width: 18, height: 18, borderRadius: "50%",
                background: "white",
                position: "absolute", top: 3,
                left: s.on ? 23 : 3,
                transition: "left 0.2s",
                boxShadow: "0 1px 4px rgba(0,0,0,0.3)",
              }}
            />
          </div>
        </div>
      ))}

      {/* Save note */}
      <div style={{ marginTop: 20, fontSize: 12, color: "rgba(255,255,255,0.25)", lineHeight: 1.6 }}>
        💡 Settings are saved automatically.{" "}
        <span style={{ color: "rgba(255,107,53,0.6)" }}>
          When you connect Supabase, these will be stored per merchant account.
        </span>
      </div>
    </div>
  );
}
